import { Layout, Menu } from 'antd';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { ROUTES } from '@/constants';

const MENU_ITEMS = [
  {
    to: ROUTES.topGacha,
    label: 'ガチャ一覧',
  },
  {
    to: ROUTES.topExportAllRegistersAsCsv,
    label: '全登録者のCSV出力',
  },
  {
    to: ROUTES.topEmailSend,
    label: '全登録者へのメール送信',
  },
];

const TopSider: React.FC<{}> = () => {
  const location = useLocation();
  return (
    <Layout.Sider className="site-layout-background" breakpoint="lg" collapsedWidth="0">
      <Menu mode="inline" theme="dark" selectedKeys={[location.pathname]}>
        {MENU_ITEMS.map((menu) => (
          <Menu.Item key={menu.to}>
            <Link to={menu.to}>{menu.label}</Link>
          </Menu.Item>
        ))}
      </Menu>
    </Layout.Sider>
  );
};

export default TopSider;
